// data abt my internship experience

const experienceData = {
  internships: [
    {
      emoji: "🌎",
      company: "NVIDIA",
      role: "Generative AI Software Engineer",
      dates: "Present",
      type: "internship",
      highlight: true,
      description: "Helping world models understand the physical world with ",
      linkText: "Cosmos3",
      linkUrl: "https://research.nvidia.com/labs/cosmos-lab/cosmos3/",
    },
    {
      emoji: "👮🏾",
      company: "Stanford AI Lab",
      role: "Research Assistant",
      advisor: "Dan Jurafsky",
      dates: "Fall 2025",
      type: "research",
      description:
        "Building data pipelines for large-scale analysis of body-camera footage",
    },
    {
      emoji: "🧠",
      company: "Stanford Scaling Intelligence Lab",
      role: "Summer Research Intern",
      advisor: "Azalia Mirhoseini",
      dates: "Summer 2025",
      type: "research",
      description:
        "Researching long-context reasoning in language models, toward billion-token context lengths",
    },
    {
      emoji: "🎮",
      company: "NVIDIA",
      role: "Generative AI Software Engineering Intern",
      dates: "Fall 2024",
      type: "internship",
      description: "Building video-generation world foundation models with ",
      linkText: "Cosmos1",
      linkUrl: "https://build.nvidia.com/nvidia/cosmos-predict1-7b",
    },
    {
      emoji: "💸",
      company: "IMC Trading",
      role: "Software Engineering Intern",
      dates: "Summer 2024",
      type: "internship",
      description:
        "Developing software tools to support trading decisions and analysis",
    },
    {
      emoji: "👩🏽‍🏫",
      company: "Stanford CS",
      role: "Section Leader, CS 106B: Programming Abstractions",
      dates: "Since Spring 2023",
      type: "teaching",
      description:
        "Leading sections, providing office hours, and teaching algorithms, data structures, and software design",
    },
    {
      emoji: "🔬",
      company: "Stanford SALT (Social & Language Technologies Lab)",
      role: "Undergraduate Researcher",
      advisor: "Diyi Yang",
      dates: "Since Jan 2023",
      type: "research",
      description:
        "Investigating conversational grounding in language models; co-author of ",
      linkText: "Grounding Gaps in Language Model Generations",
      linkUrl: "https://arxiv.org/abs/2311.09144",
    },
    {
      emoji: "✈️",
      company: "Lockheed Martin",
      role: "Software Engineering Intern",
      dates: "Summer 2023",
      type: "internship",
      description:
        "Designing a supply-chain data pipeline that accelerated data transfer by 2000x",
    },
    // {
    //   emoji: "🛍️",
    //   company: "Tata Digital",
    //   role: "Deep Analytics/AI Intern",
    //   dates: "Summer 2022",
    //   description:
    //     "Built recommendation engine on a graph database to inform customer-facing chatbot with intelligent responses to 'Where's my order???' and provide companies with item return probabilities.",
    // },
    // {
    //   emoji: "📚",
    //   company: "Google",
    //   role: "Dataset Contractor",
    //   dates: "Spring/Summer 2022",
    //   description:
    //     "Processed physics problem datasets into LaTeX for use in instructional language models.",
    // },
  ],
};

export default experienceData;
